import { objectToUrlParams } from './urlParams';
import axios from 'axios';
import downloadFile from './downloadFile';
import { applicationTypeXls } from './constants';
import { laravelHttpClient, coreHttpClient } from '../adlevo-vue/axios/axios';

/**
 * Endpoint for requests.
 */
export default {
	user: {
		register: {
			supplier: supplierData => laravelHttpClient.post('/register/supplier', supplierData),
			partner: partnerData => laravelHttpClient.post('/register/partner', partnerData),
			validate: {
				partner: {
					validatePersonalData: data => laravelHttpClient.post('/register/partner/validate/personal-data', data),
					validateBusinessModels: data => laravelHttpClient.post('/register/partner/validate/business-models', data),
				},
			},
		},
		profile: {
			update: {
				partner: partnerProfileData => laravelHttpClient.post('/profile/partner/update', partnerProfileData),
				supplier: supplierProfileData => laravelHttpClient.post('/profile/supplier/update', supplierProfileData),

				zaui: zauiId => laravelHttpClient.post('/profile/supplier/zaui/update', zauiId),
				expb: expbId => laravelHttpClient.post('/profile/supplier/expb/update', expbId),
			},
			whiteLabel: {
				store: data => laravelHttpClient.post('/profile/partner/white-label/store', data),
				pendingChange: {
					store: (data, id) => laravelHttpClient.post(`/profile/partner/white-label/pending-change/store/${id}`, data),
				},
				validatePhotos: data => laravelHttpClient.post('/profile/partner/white-label/validate-photos', data),
				show: id => laravelHttpClient.get(`/profile/partner/white-label/show/${id}`),
				viewServices: (data, whiteLabelId) =>
					laravelHttpClient.post(`/profile/partner/white-label/view-services/${whiteLabelId}`, data),
				viewMyServices: (data, whiteLabelId) =>
					laravelHttpClient.post(`/profile/partner/white-label/view-my-services/${whiteLabelId}`, data),
				storeService: (data, whiteLabelId) =>
					laravelHttpClient.post(`/profile/partner/white-label/store-service/${whiteLabelId}`, data),
				updateService: (data, whiteLabelId) =>
					laravelHttpClient.post(`/profile/partner/white-label/update-service/${whiteLabelId}`, data),
			},
			affiliateLink: {
				tour: {
					view: data => laravelHttpClient.post(`/profile/partner/affiliate-link/tour/view`, data),
				},
			},

			booking: {
				list: (data, tourId) =>
					laravelHttpClient.post(`/profile/supplier/booking/list/${tourId !== undefined ? tourId : ''}`, data),
				countForDate: (data, tourId) => laravelHttpClient.post(`/profile/supplier/booking/count-date/${tourId}`, data),
				countForMonth: (data, tourId) =>
					laravelHttpClient.post(`/profile/supplier/booking/count-month/${tourId}`, data),
				cancel: (data, bookingId) => laravelHttpClient.post(`/profile/supplier/booking/cancel/${bookingId}`, data),
			},

		},
	},
	admin: {
		user: {
			partner: {
				pending: {
					approve: (data, id) => laravelHttpClient.post(`admin/user/partner/pending/approve/${id}`, data),
					deny: (data, id) => laravelHttpClient.post(`admin/user/partner/pending/deny/${id}`, data),
					change: {
						approve: id => laravelHttpClient.get(`admin/user/partner/pending/change/approve/${id}`),
						deny: (data, id) => laravelHttpClient.post(`admin/user/partner/pending/change/deny/${id}`, data),
					},
				},
				update: (data, id) => laravelHttpClient.post(`admin/user/partner/update/${id}`, data),
				updatePassword: (data, id) => laravelHttpClient.post(`admin/user/partner/update-password/${id}`, data),
			},
			supplier: {
				pending: {
					approve: id => laravelHttpClient.get(`admin/user/supplier/pending/approve/${id}`),
					deny: (data, id) => laravelHttpClient.post(`admin/user/supplier/pending/deny/${id}`, data),
					change: {
						approve: id => laravelHttpClient.get(`admin/user/supplier/pending/change/approve/${id}`),
						deny: (data, id) => laravelHttpClient.post(`admin/user/supplier/pending/change/deny/${id}`, data),
					},
				},
				update: (data, id) => laravelHttpClient.post(`admin/user/supplier/update/${id}`, data),
				updatePassword: (data, id) => laravelHttpClient.post(`admin/user/supplier/update-password/${id}`, data),
				connection: {
					expb: {
						test: data => laravelHttpClient.post('admin/user/supplier/connection/expb/test', data),
					},
				},
			},
			admin: {
				create: data => laravelHttpClient.post('admin/user/administrator/store', data),
			},
		},
		contacts: {
			contactInformation: {
				save: data => laravelHttpClient.post('admin/contacts/contact-information/save', data),
			},
		},
		settings: {
			site: {
				update: data => laravelHttpClient.post(`admin/settings/site`, data),
			},
			mainPage: {
				update: (data, id) => laravelHttpClient.post(`admin/settings/main-page/update/${id}`, data),
			},
			mainPreamble: {
				update: data => laravelHttpClient.post(`admin/settings/main-preamble-api/save`, data),
			},
			commission: {
				update: data => laravelHttpClient.post('admin/settings/update-commission', data),
			},
			reviews: {
				update: data => laravelHttpClient.post('admin/settings/update-reviews-settings', data),
			},
			analytics: {
				update: data => laravelHttpClient.post('admin/settings/update-analytics-settings', data),
			},
		},
		taxCategories: {
			create: data => laravelHttpClient.post('admin/tax-categories/create', data),
			update: (id, data) => laravelHttpClient.post(`admin/tax-categories/update/${id}`, data),
			setDefault: id => laravelHttpClient.post(`admin/tax-categories/set-default/${id}`),
		},
		commissionCategories: {
			create: data => coreHttpClient.post('settings/commission/category', data),
			update: (id, data) => coreHttpClient.put(`settings/commission/category/${id}`, data),
			setDefault: id => laravelHttpClient.post(`admin/commission-categories/set-default/${id}`),
		},
		whiteLabel: {
			updatePreamble: (data, id) => laravelHttpClient.post(`admin/white-label/update-preamble/${id}`, data),
			resetPreamble: id => laravelHttpClient.post(`admin/white-label/reset-preamble/${id}`),
			updateCommission: (data, id) => laravelHttpClient.post(`admin/white-label/update-commission/${id}`, data),
			updateCategories: (data, id) => laravelHttpClient.post(`admin/white-label/update-categories/${id}`, data),
			updateCommissionCategory: (data, id) =>
				laravelHttpClient.post(`admin/white-label/commission-category/${id}`, data),
			updateAdditionalCommission: (data, id) =>
				laravelHttpClient.post(`admin/white-label/update-additional-commission/${id}`, data),
			updateSelfProductCommission: (data, id) =>
				laravelHttpClient.post(`admin/white-label/update-self-product-commission/${id}`, data),
			updateFontSize: (data, id) => laravelHttpClient.post(`admin/white-label/update-font-size/${id}`, data),
			updateChatbotAssistant: (data, id) => coreHttpClient.post(`partner-sites/${id}/chatbot/assistant`, data),
			updateAnalytics: (data, id) => laravelHttpClient.post(`admin/white-label/update-analytics/${id}`, data),
			updateHeadScripts: (data, id) => laravelHttpClient.post(`admin/white-label/update-head-scripts/${id}`, data),
			updateFooterScripts: (data, id) => laravelHttpClient.post(`admin/white-label/update-footer-scripts/${id}`, data),
			updateHiddenFromProductListing: (data, id) => coreHttpClient.put(`partner-sites/${id}/hidden-from-product-listing`, data),

			destroy: (data, id) => laravelHttpClient.post(`admin/white-label/destroy/${id}`, data),
			deactivate: (data, id) => laravelHttpClient.post(`admin/white-label/deactivate/${id}`, data),
			activate: id => laravelHttpClient.get(`admin/white-label/activate/${id}`),
			pending: {
				approve: (data, id) => laravelHttpClient.post(`admin/white-label/pending/approve/${id}`, data),
				deny: (data, id) => laravelHttpClient.post(`admin/white-label/pending/deny/${id}`, data),
			},
			pendingChange: {
				approve: id => laravelHttpClient.get(`admin/white-label/pending-change/approve/${id}`),
				deny: (data, id) => laravelHttpClient.post(`admin/white-label/pending-change/deny/${id}`, data),
			},
		},

		utils: {
			slugify: data => laravelHttpClient.post('admin/utils/slugify', data),
		},

		select: {
			category: {
				store: data => laravelHttpClient.post(`admin/select/category/store`, data),
				update: (data, id) => laravelHttpClient.post(`admin/select/category/update/${id}`, data),
				destroy: id => laravelHttpClient.get(`admin/select/category/destroy/${id}`),
				byServiceID: id => coreHttpClient.get(`admin/select/category/service-category/${id}`),
			},
			recommendation: {
				store: data => laravelHttpClient.post(`admin/select/recommendation/store`, data),
				update: (data, id) => laravelHttpClient.post(`admin/select/recommendation/update/${id}`, data),
				destroy: id => laravelHttpClient.get(`admin/select/recommendation/destroy/${id}`),
			},
			tag: {
				store: data => coreHttpClient.post(`admin/select/tag`, data),
				update: (data, id) => coreHttpClient.put(`admin/select/tag/${id}`, data),
				destroy: id => coreHttpClient.delete(`admin/select/tag/${id}`),
			},
			businessType: {
				store: data => coreHttpClient.post(`admin/select/business-type`, data),
				update: (data, id) => coreHttpClient.put(`admin/select/business-type/${id}`, data),
				destroy: id => coreHttpClient.delete(`admin/select/business-type/${id}`),
			},
			serviceCategory: {
				store: data => coreHttpClient.post(`admin/select/service-category`, data),
				update: (data, id) => coreHttpClient.put(`admin/select/service-category/${id}`, data),
				destroy: id => coreHttpClient.delete(`admin/select/service-category/${id}`),
			},
		},
		report: {
			download: params =>
				laravelHttpClient({
					url: `admin/report/download`,
					method: 'POST',
					responseType: 'blob',
					data: params,
				})
					.then(response => {
						downloadFile(response, applicationTypeXls);
						return Promise.resolve(response);
					})
					.catch(Promise.reject),
		},
		tools: {
			zaui: {
				sync: tour => laravelHttpClient.post(`admin/tools/zaui/sync/${tour}`),
				loadZauiAllotments: tour => laravelHttpClient.post(`admin/tools/zaui/load-zaui/${tour}`),
				loadLocalAllotments: tour => laravelHttpClient.post(`admin/tools/zaui/load-allotment/${tour}`),
				resetLocalAllotments: tour => laravelHttpClient.post(`admin/tools/zaui/reset-allotment/${tour}`),
			},
			expb: {
				sync: tour => laravelHttpClient.post(`admin/tools/expb/sync/${tour}`),
				loadExpbAllotments: tour => laravelHttpClient.post(`admin/tools/expb/availability/${tour}`),
				loadExpbActivity: tour => laravelHttpClient.post(`admin/tools/expb/activity/${tour}`),
			},
		},
		earnings: {
			supplier: {
				markPaid: earningId => laravelHttpClient.post(`/admin/earnings/supplier/mark-paid/${earningId}`),
				markLocked: earningId => laravelHttpClient.post(`/admin/earnings/supplier/mark-locked/${earningId}`),
				markPending: earningId => laravelHttpClient.post(`/admin/earnings/supplier/mark-pending/${earningId}`),
				transfer: earningId => laravelHttpClient.post(`/admin/earnings/supplier/transfer/${earningId}`),
			},
		},
		cancellations: {
			noRefund: cancellationId => laravelHttpClient.post(`/admin/cancellations/no-refund/${cancellationId}`),
			refund: cancellationId => laravelHttpClient.post(`/admin/cancellations/refund/${cancellationId}`),
		},
		text: {
			blog: {
				update: (data, id) => laravelHttpClient.post(`admin/text/blog/update/${id}`, data),
			},
			informationText: {
				update: (data, id) => laravelHttpClient.post(`admin/text/information/update/${id}`, data),
			},
			aboutUs: {
				update: (data, id) => laravelHttpClient.post(`admin/text/about-us/update/${id}`, data),
			},
			commissionTerms: {
				update: (data, id) => laravelHttpClient.post(`admin/text/commission-term/update/${id}`, data),
			},
			termsOfUse: {
				update: (data, id) => laravelHttpClient.post(`admin/text/terms-of-use/update/${id}`, data),
			},
			termsAndConditions: {
				update: (data, id) => laravelHttpClient.post(`admin/text/terms-and-conditions/update/${id}`, data),
			},
			policyAndPrivacy: {
				update: (data, id) => laravelHttpClient.post(`admin/text/policy-privacy/update/${id}`, data),
			},
			partnerRegistration: {
				update: (data, id) => laravelHttpClient.post(`admin/text/partner-registration/update/${id}`, data),
			},
		},
		rental: {
			fetchByID: id => laravelHttpClient.get(`admin/rental/get/${id}`),
			store: data => laravelHttpClient.post(`admin/rental/store`, data),
			update: (data, id) => laravelHttpClient.post(`admin/rental/update/${id}`, data),
			destroy: id => laravelHttpClient.post(`admin/rental/destroy/${id}`),

			comments: {
				delete: id => laravelHttpClient.get(`admin/rental/comment/destroy/${id}`),
			},
		},
		restaurant: {
			fetchByID: id => laravelHttpClient.get(`admin/restaurant/get/${id}`),
			store: data => laravelHttpClient.post(`admin/restaurant/store`, data),
			update: (data, id) => laravelHttpClient.post(`admin/restaurant/update/${id}`, data),
			destroy: id => laravelHttpClient.post(`admin/restaurant/destroy/${id}`),

			comments: {
				delete: id => laravelHttpClient.get(`admin/restaurant/comment/destroy/${id}`),
			},
		},
		activity: {
			fetchByID: id => laravelHttpClient.get(`admin/activity/get/${id}`),
			store: data => laravelHttpClient.post(`admin/activity/store`, data),
			update: (data, id) => laravelHttpClient.post(`admin/activity/update/${id}`, data),
			destroy: id => laravelHttpClient.post(`admin/activity/destroy/${id}`),

			comments: {
				delete: id => laravelHttpClient.get(`admin/activity/comment/destroy/${id}`),
			},
		},
		location: {
			store: locationData => {
				return laravelHttpClient.post('locations/store', locationData);
			},
			update: (locationData, locationId) => {
				return laravelHttpClient.post('locations/update/' + locationId, locationData);
			},
		},
	},
	public: {
		tour: {
			submitQuestion: (data, id) => laravelHttpClient.post(`/tour/submit-question/${id}`, data),
			view: tourId => laravelHttpClient.get(`/tour/view/${tourId}`),
			comment: {
				store: (commentData, tourId) => laravelHttpClient.post(`/tour/${tourId}/comment/store`, commentData),
				get: (tourId, page) =>
					laravelHttpClient.get(`/tour/${tourId}/comment${page !== undefined ? `?page=${page}` : ''}`),
			},
			booking: {
				checkAvailability: (data, tourId) => laravelHttpClient.post(`/tour/availability/${tourId}`, data),
			},
			availability: {
				check: (data, tourId) => laravelHttpClient.post(`/tour/availability/${tourId}`, data),
				getBusyDates: (data, tourId) => laravelHttpClient.post(`/tour/busy-dates/${tourId}`, data),
				getEmptyDates: (data, tourId) => laravelHttpClient.post(`/tour/empty-dates/${tourId}`, data),
			},
			basket: {
				tourStructureForCart: data => laravelHttpClient.post(`/basket/tour-structure-for-cart`, data),
				validateTourItem: data => laravelHttpClient.post(`/basket/validate-tour-item`, data),
				validateHotelItem: data => laravelHttpClient.post(`/basket/validate-hotel-item`, data),
			},
			getTourNameAndCategorySearch: searchKey => {
				var searchValue = searchKey ? '?query=' + searchKey.trim() : '';
				return laravelHttpClient.get('/search/group' + searchValue);
			},
		},
		rental: {
			submitQuestion: (data, id) => laravelHttpClient.post(`/rental/submit-question/${id}`, data),
			comment: {
				store: (commentData, rentalId) => laravelHttpClient.post(`/rental/${rentalId}/comment/store`, commentData),
				get: (rentalId, page) =>
					laravelHttpClient.get(`/rental/${rentalId}/comment${page !== undefined ? `?page=${page}` : ''}`),
			},
		},
		restaurant: {
			submitQuestion: (data, id) => laravelHttpClient.post(`/restaurant/submit-question/${id}`, data),
			comment: {
				store: (commentData, restaurantId) =>
					laravelHttpClient.post(`/restaurant/${restaurantId}/comment/store`, commentData),
				get: (restaurantId, page) =>
					laravelHttpClient.get(`/restaurant/${restaurantId}/comment${page !== undefined ? `?page=${page}` : ''}`),
			},
		},
		activity: {
			submitQuestion: (data, id) => laravelHttpClient.post(`/activity/submit-question/${id}`, data),
			comment: {
				store: (commentData, activityId) =>
					laravelHttpClient.post(`/activity/${activityId}/comment/store`, commentData),
				get: (activityId, page) =>
					laravelHttpClient.get(`/activity/${activityId}/comment${page !== undefined ? `?page=${page}` : ''}`),
			},
		},
		catalog: {
			view: data => laravelHttpClient.post(`catalog`, data),
			show: id => laravelHttpClient.get(`catalog/show/${id}`),
			showRecommended: cartTours => laravelHttpClient.post(`catalog/show-recommended`, cartTours),
			addToCookies: tourId => laravelHttpClient.get(`catalog/add-to-cart/${tourId}`),
			removeFromCookies: tourId => laravelHttpClient.get(`catalog/remove-from-cart/${tourId}`),
		},

		languages: {
			get: () => laravelHttpClient.get('/languages'),
		},

		checkout: {
			validate: data => laravelHttpClient.post('checkout/validate-items', data),
			placeOrder: data => laravelHttpClient.post('checkout/place-order', data),
			getStripeKey: data => laravelHttpClient.post('stripe/get-key', data),
			updatePaymentStatus: data => laravelHttpClient.post(`checkout/update-payment`, data),
			getPayyoVault: data => laravelHttpClient.post('payyo/vault', data),
			getPaymentStatus: payment => laravelHttpClient.get(`payment/${payment}/status`),
		},
		contactForm: {
			send: data => laravelHttpClient.post('contacts/send-mail', data),
		},
		stats: {
			mobileBookNow: {
				push: data => laravelHttpClient.post('statistics/mobile/book-now-clicks', data),
			},
		},
		logs: {
			clientErrors: {
				push: data => laravelHttpClient.post('logs/client-errors', data),
			},
		},
		location: {
			getLocations: searchKey => {
				var searchValue = searchKey ? '?name=' + searchKey.trim() : '';
				return laravelHttpClient.get('locations/search' + searchValue);
			},
		},
	},
	maps: {
		// Google Maps API docs
		// https://developers.google.com/maps/documentation/geocoding/start
		geocode: uriParams =>
			axios({
				url: `https://maps.googleapis.com/maps/api/geocode/json${objectToUrlParams(uriParams)}`,
				method: 'GET',
				responseType: 'json',
			}),
	},
};
